import { render } from "./BlockUserDialog.vue?vue&type=template&id=174c0e98&scoped=true"
import script from "./BlockUserDialog.vue?vue&type=script&lang=js"
export * from "./BlockUserDialog.vue?vue&type=script&lang=js"

import "./BlockUserDialog.vue?vue&type=style&index=0&id=174c0e98&scoped=true&lang=scss"

import exportComponent from "/home/runner/work/dating-app/dating-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-174c0e98"]])

export default __exports__